// Zentrale Supabase-Konfiguration
// Bei Migration nur diese Datei anpassen!

export const SUPABASE_CONFIG = {
  // Basis-URL des Supabase-Projekts
  url: "https://puwkrtqzszjsjkxowvin.supabase.co",
  
  // Anon/Publishable Key (öffentlich)
  anonKey: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InB1d2tydHF6c3pqc2preG93dmluIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTQwOTAyODIsImV4cCI6MjA2OTY2NjI4Mn0.fwAQ1FmbzQBnAmieAdM95-HA21iIm3jWVIcP58zMJxw",
  
  // Project ID
  projectId: "puwkrtqzszjsjkxowvin",
} as const;

// Abgeleitete URLs
export const SUPABASE_STORAGE_URL = `${SUPABASE_CONFIG.url}/storage/v1/object/public`;
export const SUPABASE_FUNCTIONS_URL = `${SUPABASE_CONFIG.url}/functions/v1`;
